export const CUSTOMER_DATA_LOADING_ERROR = 'Fehler beim Laden der Kundendaten!';
export const TRANSACTIONS_DATA_LOADING_ERROR = 'Fehler beim Laden der Transaktionen!';
export const TRANSACTIONS_PDF_GENERATION_ERROR = 'Fehler bei Erzeugung des Transaktionsdokumentes (PDF)';

export const TRANSACTION_ORDER_TYPE = {
  TRANSACTION: 1,
  BOOKING: 2
};